var kit_carousel = false;

jQuery(document).ready(function ($) {
  var $slots = $(".kit-selection .slot");
  var $kitAddButtons = $(".kit-item .btn.add-to-kit");
  $kitAddButtons.each(function () { $(this).attr('data-kit-stock-disabled', String(this.disabled)); });

  function kitBusy() { return $('.kit-selection-block').hasClass('loading'); }
  function emptySlots() { return $slots.not('.filled'); }
  var kitFocusRevision = 0;
  // A newer keyboard or pointer action takes precedence over deferred focus.
  document.addEventListener('keydown', function () { kitFocusRevision++; }, true);
  document.addEventListener('pointerdown', function () { kitFocusRevision++; }, true);
  function focusKitItem($item) {
    var revision = ++kitFocusRevision, frames = 0;
    function focusWhenVisible() {
      if (revision !== kitFocusRevision) return;
      var $target = $item.find('.qc-inc:not(:disabled)').first();
      if (!$target.length) $target = $item.find('.qc-dec:not(:disabled)').first();
      if (!$target.length) $target = $item.find('.add-to-kit:not(:disabled)').first();
      if (!$target.length || !document.documentElement.contains($target[0])) return;
      var rect = $target[0].getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) $target[0].focus({ preventScroll: true });
      // The controls animate from scale(0); focusing them before the next
      // painted frame can fail and leave the keyboard user on the background.
      else if (++frames < 20) requestAnimationFrame(focusWhenVisible);
    }
    requestAnimationFrame(focusWhenVisible);
  }
  function syncKitControls() {
    var busy = kitBusy(), full = $slots.length > 0 && emptySlots().length === 0;
    $('.kit-selection-block, .kit-content').toggleClass('full', full);
    $('.kit-item').each(function () {
      var $item = $(this), active = $item.hasClass('active');
      $item.find('.qc-dec').prop('disabled', busy || !active);
      $item.find('.qc-inc').prop('disabled', busy || !active || full);
      $item.find('.add-to-kit').each(function () {
        this.disabled = busy || full || active || $(this).attr('data-kit-stock-disabled') === 'true';
      });
    });
    $slots.find('.remove-btn').each(function () {
      var $button = $(this), $slot = $button.closest('.slot');
      this.disabled = busy || !$slot.hasClass('filled') || $slot.hasClass('main-product');
      var title = $slot.find('.title-hold').text().trim();
      var label = $button.attr('data-remove-label') || 'Remove';
      $button.attr('aria-label', label + (title ? ' ' + title : ''));
    });
  }
  syncKitControls();

  $(".kit-item .btn.add-to-kit")
    .not("[disabled]")
    .click(function (e) {
      e.preventDefault();
      if (kitBusy() || !emptySlots().length || this.disabled) return;
      var hadFocus = document.activeElement === this;
      var $item = $(this).closest(".kit-item");
      $item.addClass("active");
      addKitItem($item);
      if (hadFocus) focusKitItem($item);
    });

  var $kitOpeners = $(".open-kit-builder");
  var $kitSections = $(".shopify-section.kit-builder-block");
  var $previewSections = $(".shopify-section:not(.kit-builder-block)");
  var kitViewOpen = null;
  var lastKitFocus = null;
  var lastPreviewFocus = null;

  function syncKitView(moveFocus) {
    // Mist-only packs have a preview too, even without a main equipment item.
    if (!$kitOpeners.length || !$kitSections.length) return;
    var open = window.location.hash === '#builder';
    if (kitViewOpen === open) return;
    var previous = kitViewOpen;
    var active = document.activeElement;
    var inBuilder = $(active).closest('.kit-builder-block').length > 0;
    var inPreview = $(active).closest('.shopify-section').not('.kit-builder-block').length > 0;
    if (!open && inBuilder) lastKitFocus = active;
    if (open && $kitOpeners.is(active)) lastPreviewFocus = active;
    kitViewOpen = open;
    kitFocusRevision++;
    $kitSections.toggle(open);
    $previewSections.toggle(!open);
    if (open && previous !== null) kitSelectionFixed();

    if (!moveFocus || (!inBuilder && !inPreview && active !== document.body)) return;
    var target = open ? lastKitFocus : lastPreviewFocus;
    if (!target || !document.documentElement.contains(target) || target.disabled || !target.getClientRects().length) {
      target = open ? $kitSections.find('.pack-name').first()[0] : $kitOpeners.filter(':visible:not(:disabled)').first()[0];
    }
    if (target) {
      if (open && $(target).hasClass('pack-name')) target.tabIndex = -1;
      target.focus({ preventScroll: true });
    }
  }

  $kitOpeners.click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.disabled || !$kitSections.length) return;
    lastPreviewFocus = this;
    if (window.location.hash !== '#builder') {
      if (window.history.pushState) {
        var url = window.location.pathname + window.location.search + '#builder';
        window.history.pushState(window.history.state, '', url);
      } else window.location.hash = '#builder';
    }
    syncKitView(true);
  });

  // Listen alongside other integrations instead of replacing onhashchange.
  window.addEventListener('popstate', function () { syncKitView(true); });
  window.addEventListener('hashchange', function () { syncKitView(true); });
  window.addEventListener('pageshow', function () { syncKitView(false); });
  syncKitView(false);

  $(".quantity-controls .qc-dec").click(function (e) {
    e.preventDefault();
    if (kitBusy() || this.disabled) return;
    var hadFocus = document.activeElement === this;
    var $indicator = $(this).parent().find(".qc-indicator");
    var num = parseInt($indicator.text());
    var $item = $(this).closest(".kit-item");
    if (num === 1) {
      $item.removeClass("active");
    } else {
      $indicator.text(--num);
    }
    var $slot = $(
      '.kit-selection .slot[data-variant-id="' + $item.data("variant-id") + '"]'
    ).last();
    removeKitItem($slot);
    if (hadFocus && this.disabled) focusKitItem($item);
  });

  $(".quantity-controls .qc-inc").click(function (e) {
    e.preventDefault();
    if (kitBusy() || this.disabled || emptySlots().length === 0) {
      return;
    }
    var $indicator = $(this).parent().find(".qc-indicator");
    var num = parseInt($indicator.text());
    $indicator.text(++num);

    var hadFocus = document.activeElement === this;
    var $item = $(this).closest(".kit-item");
    addKitItem($item);
    if (hadFocus && this.disabled) focusKitItem($item);
  });

  $(document).on("click", ".kit-selection .slot .remove-btn", function (e) {
    e.preventDefault();
    if (kitBusy() || this.disabled) return;
    var hadFocus = document.activeElement === this;
    var $slot = $(this).closest(".slot");
    if (!$slot.hasClass("filled") || $slot.hasClass("main-product")) return;
    var $item = $(
      '.kit-item[data-variant-id="' + $slot.attr("data-variant-id") + '"]'
    );

    var $indicator = $item.find(".qc-indicator");
    var num = parseInt($indicator.text());
    if (num === 1) {
      $item.removeClass("active");
    } else {
      $indicator.text(--num);
    }
    removeKitItem($slot);
    if (hadFocus) {
      var $next = $slot.find('.remove-btn:not(:disabled)').first();
      if (!$next.length) $next = $slots.filter('.filled').not('.main-product').last().find('.remove-btn:not(:disabled)');
      if ($next.length) $next[0].focus({ preventScroll: true });
      else focusKitItem($item);
    }
  });

  function addKitItem($item) {
    var $slot = emptySlots().eq(0);
    if (kitBusy() || !$slot.length) return;
    $slot.find(".img-hold").html($item.find(".imgfront")[0].outerHTML);
    $slot.find(".title-hold").html($item.find(".product-title").html());
    $slot.addClass("filled");
    $slot.attr("data-variant-id", $item.data("variant-id"));

    var empty_slots = $slots.not(".filled").length;
    $("#empty-slots").text(empty_slots);
    if (empty_slots == 1) {
      $("#mists-words").text("Mist");
    } else {
      $("#mists-words").text("Mists");
    }
    syncKitControls();
    if (kit_carousel) {
      kit_carousel.jcarousel("scroll", $slot.index());
    }
  }

  function removeKitItem($slot) {
    if (!$slot.length || !$slot.hasClass("filled") || $slot.hasClass("main-product")) return;
    var last_i = $slot.parent().find(".filled").last().index();

    var $nexts = $slot.nextAll(".filled");
    if ($nexts.length > 0) {
      $nexts.each(function () {
        var $next_slot = $(this);
        var $prev_slot = $next_slot.prev();
        if ($next_slot.hasClass("filled") && $prev_slot.length > 0) {
          $prev_slot
            .find(".img-hold")
            .html($next_slot.find(".imgfront")[0].outerHTML);
          $prev_slot
            .find(".title-hold")
            .html($next_slot.find(".title-hold").html());
          $prev_slot.addClass("filled");
          $prev_slot.attr(
            "data-variant-id",
            $next_slot.attr("data-variant-id")
          );

          if (last_i == $next_slot.index()) {
            $next_slot.removeClass("filled");
            $next_slot.removeAttr("data-variant-id");
          }
        }
      });
    } else {
      $slot.removeClass("filled");
      $slot.removeAttr("data-variant-id");
    }
    syncKitControls();

    var empty_slots = $slots.not(".filled").length;
    $("#empty-slots").text(empty_slots);
    if (empty_slots == 1) {
      $("#mists-words").text("Mist");
    } else {
      $("#mists-words").text("Mists");
    }

    if (kit_carousel) {
      kit_carousel.jcarousel("scroll", last_i);
    }
  }

  function finishKitRequest() {
    $('.kit-selection-block, .kit-content').removeClass('loading').attr('aria-busy', 'false');
    $('.kit-selection-block .add-to-cart').prop('disabled', false);
    syncKitControls();
  }

  function showKitCartError(xhr) {
    var response = xhr && xhr.responseJSON;
    if (!response && xhr && xhr.responseText) {
      try { response = JSON.parse(xhr.responseText); } catch (ignore) {}
    }
    var $error = $('.kit-cart-error');
    var message = $error.attr('data-add-error') || 'We could not add your kit. Please check your selections and try again.';
    if (response && typeof response.description === 'string' && response.description.trim()) {
      message = response.description;
    } else if (response && typeof response.message === 'string' && response.message.trim()) {
      message = response.message;
    }
    $error.text(message).show().trigger('focus');
  }

  //purchase process
  $(".kit-selection-block .add-to-cart").click(function (e) {
    e.preventDefault();
    if ($('.kit-selection-block').hasClass('loading')) return;
    $('.kit-cart-error').empty().hide();
    $('.kit-selection-block, .kit-content').addClass('loading').attr('aria-busy', 'true');
    $('.kit-selection-block .add-to-cart').prop('disabled', true);
    syncKitControls();
    addToCartV2();
  });

  function addAllItems(gift_id, gift_once_id) {
    if (typeof gift_once_id === "undefined") {
      gift_once_id = "";
    } else if (gift_once_id != "") {
      gift_id = gift_once_id;
    }
    var kit_name = $(".pack-name").text();
    var data = {
      items: [],
    };
    $(".kit-selection .slot").each(function () {
      for (var i in data.items) {
        if (data.items[i].id == $(this).attr("data-variant-id")) {
          data.items[i].quantity++;
          return;
        }
      }
      data.items.push({
        id: $(this).attr("data-variant-id"),
        quantity: 1,
        properties: {
          Kit: kit_name,
        },
      });
    });
    if (typeof gift_id !== "undefined" && gift_id != "") {
      if (gift_once_id != "") {
        $.getJSON("/cart.js", function (cart) {
          var in_cart = false;
          if (cart.items.length > 0) {
            for (var i in cart.items) {
              if (cart.items[i].variant_id == gift_id) {
                in_cart = true;
                break;
              }
            }
          }
          if (!in_cart) {
            data.items.push({
              id: gift_id,
              quantity: 1,
            });
            data.items = data.items.reverse();
            addToCartDo(data);
            return;
          } else {
            data.items = data.items.reverse();
            addToCartDo(data);
          }
        });
      } else {
        data.items.push({
          id: gift_id,
          quantity: 1,
        });
        data.items = data.items.reverse();
        addToCartDo(data);
      }
    } else {
      data.items = data.items.reverse();
      addToCartDo(data);
    }
  }

  function addToCartDo(data) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: data,
      success: function (res) {
        $(".kit-selection-block, .kit-content").removeClass("loading");
        showCartDrawer();
        fetchCart();
      },
      error: showKitCartError,
      complete: finishKitRequest,
    });
  }

  function addToCartV2() {
    var kit_variant_id = $('.open-kit-builder').data('kit-variant-id');
    var kit_name = $(".pack-name").text();
    var selected_variants = [];
    var properties = {};

    // Collect main products (pre-filled slots with main-product class)
    var main_index = 1;
    $(".kit-selection .slot.filled.main-product").each(function () {
      var variant_id = $(this).attr("data-variant-id");
      var product_title = $(this).find(".title-hold").text().trim();
      
      if (variant_id) {
        properties['_selected_main_' + main_index] = variant_id;
        properties['_selected_main_title_' + main_index] = product_title;
        properties['_selected_main_img_' + main_index] = $(this).find('img').attr('src');
        main_index++;
      }
    });

    // Collect mist products (filled slots without main-product class)
    var mist_index = 1;
    var mist_variants = [];
    $(".kit-selection .slot.filled").not(".main-product").each(function () {
      var variant_id = $(this).attr("data-variant-id");
      var product_title = $(this).find(".title-hold").text().trim();
      
      if (variant_id) {
        mist_variants.push(variant_id);
        properties['_selected_mist_' + mist_index] = variant_id;
        properties['_selected_mist_title_' + mist_index] = product_title;
        properties['_selected_mist_img_' + mist_index] = $(this).find('.img-hold img').attr('src');
        mist_index++;
      }
    });

    // Set the required number of mists (spray products only)
    properties['_mists_required'] = mist_variants.length.toString();

    const params = {
      id: kit_variant_id || 'MINE_KIT_VARIANT_ID', // The Mine Kit bundle variant ID
      quantity: 1,
      properties: properties
    };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: params,
      success: function (res) {
        $(".kit-selection-block, .kit-content").removeClass("loading");
        showCartDrawer();
        fetchCart();
      },
      error: showKitCartError,
      complete: finishKitRequest
    });
  }

  //fixed sidebar
  var fix_top = 120;
  kitSelectionFixed();
  initkitBuilderCarousel();

  $(window).scroll(function () {
    kitSelectionFixed();
  });
  $(window).resize(function () {
    kitSelectionFixed();
    initkitBuilderCarousel();
  });

  var mob_fixed = false;

  function kitSelectionFixed() {
    var scrollTop = $(window).scrollTop();
    var $elem = $(".kit-selection-block");

    var $hold = $elem.parent();
    var $block2 = $hold.find(".content-hold");
    if ($(window).width() < 768) {
      var start2 =
        $elem.offset().top +
        $elem.find(".heading").innerHeight() -
        $(".minetan-2020 .site-header .header-bottom").height() +
        8;

      if (scrollTop > start2) {
        if (!mob_fixed) {
          $hold.css(
            "height",
            $(".kit-builder .kit-content").offset().top -
              $elem.offset().top +
              "px"
          );
          mob_fixed = true;
        }
        $block2.addClass("fixed");
      } else {
        $block2.removeClass("fixed");
        mob_fixed = false;
        $hold.attr("style", "");
      }
    } else {
      $block2.removeClass("fixed");
      $hold.attr("style", "");

      // Only pin the selection when its full contents fit below the header.
      if ($elem.hasClass("fixed")) {
        $elem.css("width", $hold.innerWidth() + "px");
      }
      if ($elem.outerHeight() + fix_top > $(window).height()) {
        $elem.removeClass("fixed reach-bottom");
        $elem.attr("style", "");
        return;
      }

      var $block = $(".kit-content");
      var start = $block.offset().top;
      var end = start + $block.innerHeight();

      if (scrollTop > start - 50) {
        $elem.css("width", $elem.parent().innerWidth() + "px");
        $elem.css("top", fix_top + "px");
        $elem.addClass("fixed");
      } else {
        $elem.removeClass("fixed");
        $elem.attr("style", "");
      }

      if (scrollTop + $elem.innerHeight() + fix_top >= end - 35) {
        $elem.addClass("reach-bottom");
        $elem.css("bottom", "35px");
      } else {
        $elem.removeClass("reach-bottom");
        $elem.css("bottom", "auto");
      }
    }
  }

  function initkitBuilderCarousel() {
    if ($(window).width() < 768) {
      if (!kit_carousel) {
        var kit_carousel_hold =
          ".kit-selection-block .content-hold .kit-slider";
        kit_carousel = $(kit_carousel_hold).jcarousel({
          wrap: null,
        });
        /*kit_carousel.on('jcarousel:reload jcarousel:create', function() {
          kit_carousel.jcarousel('items').css('width', '128px');
        }).jcarousel({
          wrap: null
        })*/

        $(kit_carousel_hold).unbind("swipeleft");
        $(kit_carousel_hold).unbind("swiperight");

        $(kit_carousel_hold).bind("swipeleft", function () {
          kit_carousel.jcarousel("scroll", "+=1");
        });
        $(kit_carousel_hold).bind("swiperight", function () {
          kit_carousel.jcarousel("scroll", "-=1");
        });
      }
    } else {
      if (kit_carousel) {
        kit_carousel.jcarousel("destroy");
        kit_carousel = false;
      }
    }
  }
});
